var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.60792 2.36226L5.94417 2.69851L6.28042 2.36226L6.94798 1.6947C7.96937 0.673311 9.62537 0.673311 10.6468 1.6947C11.6682 2.71609 11.6682 4.37209 10.6468 5.39348L5.94417 10.0961L1.24158 5.39348C0.220186 4.37209 0.220186 2.71609 1.24158 1.6947C2.26297 0.673311 3.91897 0.673311 4.94036 1.6947L5.60792 2.36226Z",
    fill: "#02215F",
    stroke: "#02215F",
    strokeWidth: 0.951067,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartFilled);
export default __webpack_public_path__ + "static/media/heartFilled.a748eac4c925b54921319d0ece9520c9.svg";
export { ForwardRef as ReactComponent };